'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AttachFileOutline = function AttachFileOutline(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 120 120"
  }), React__default["default"].createElement("g", {
    fill: "none",
    "fill-rule": "evenodd"
  }, React__default["default"].createElement("rect", {
    width: "120",
    height: "120",
    fill: "#ECEFF1",
    rx: "16"
  }), React__default["default"].createElement("path", {
    fill: "#000",
    "fill-opacity": ".12",
    d: "M75 40v38.333c0 7.367-5.967 13.334-13.333 13.334-7.367 0-13.334-5.967-13.334-13.334V36.667c0-4.6 3.734-8.334 8.334-8.334S65 32.067 65 36.667v35C65 73.5 63.5 75 61.667 75c-1.834 0-3.334-1.5-3.334-3.333V40h-5v31.667c0 4.6 3.734 8.333 8.334 8.333S70 76.267 70 71.667v-35c0-7.367-5.967-13.334-13.333-13.334-7.367 0-13.334 5.967-13.334 13.334v41.666c0 10.134 8.2 18.334 18.334 18.334C71.8 96.667 80 88.467 80 78.333V40h-5z"
  })));
};

var AttachFileOutline$1 = iconStyles()(AttachFileOutline);

module.exports = AttachFileOutline$1;
